import {v4 as guid} from 'uuid';
import * as requestFromServer from './partnersCrud';
import {
  partnersSlice,
  callTypes
} from './partnersSlice';
import {RequestCancellationManager} from '../../_common/utils/RequestCancellationManager';
import {showGlobalMessage} from "../../_common/actions/globalMessage/showGlobalMessage";
import {messages as M} from "../../../../_metronic/i18n/messages";
import {logUserAction} from '../../../../utils';
import {pages as P} from '../../_common/constants/pages';
import {subjects as S} from '../../_common/constants/subjects';
import {actionTypes as T} from '../../_common/constants/actionTypes';
import {logMessages as L} from '../../_common/constants/logMessages';

export const getPartnersListIDPrefix = 'getPartnersList';
const {actions} = partnersSlice;

const getPartnersList = storeMethod => queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.list}));

  const requestID = `${getPartnersListIDPrefix}-${guid()}`;
  const cancellationHandlers = RequestCancellationManager.createCancellationHandlers(requestID);

  return requestFromServer
    .findPartners(queryParams, cancellationHandlers)
    .then(response => {
      const {errorCode, data: {totalUsersCount, usersList, pageCount}} = response.data;
      if (errorCode !== 0) throw new Error();

      dispatch(storeMethod({
        totalUsersCount,
        pageCount,
        entities: usersList
      }));
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t find partners';
      dispatch(actions.catchError({error, callType: callTypes.list}));
    })
    .finally(() => {
      RequestCancellationManager.forgetRequest(requestID);
    });
};

export const getPartnersOptions = () => dispatch => {
  return requestFromServer
    .getPartnersOptions()
    .then(response => {

      return response.data.data.partnersList;
    })
    .then(options => {
      dispatch(actions.setPartnersOptions({options}));
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = "Can't find customers";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const exportPartnersFileAction = queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .getPartnersFile(queryParams)
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      return data.usersList;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = "Can't get file!";
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const createPartner = data => dispatch => {

  return requestFromServer
    .createPartner(data)
    .then(response => {
      const {errorCode, data: responseData} = response.data;
      logUserAction(
        P.PARTNERS,
        S.PARTNER,
        T.CREATE,
        L.PARTNERS_CREATE(data?.name),
        errorCode
      );
      if (errorCode === 0) {
        dispatch(showGlobalMessage(M.REQUEST_ENDED_SUCCESSFULLY));
        dispatch(actions.addPartnersOptions(responseData));
      } else {
        dispatch(showGlobalMessage(M[errorCode]));
      }
      return errorCode
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t send data';
    });
};

export const getPartners = getPartnersList(actions.partnersFetched);
export const getNextPartners = getPartnersList(actions.partnersAppended);
